export type IconSize = 'sm' | 'md' | 'lg';
export const ICON_SIZE_MAP: { [key in IconSize]: number | string } = {
  sm: 16,
  md: 20,
  lg: 24,
};
